import TIMEZONE_TO_SHORT from "./mappings";

const getTimezoneKey = (value: string): string => TIMEZONE_TO_SHORT[value] || value;

export default getTimezoneKey;